import { useEffect, useRef, useState } from 'react';

export default function Loader() {
  const barRef = useRef(null);
  const [percent, setPercent] = useState(0);
  const [fading, setFading] = useState(false);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    const bar = barRef.current;
    if (!bar) return;

    requestAnimationFrame(() => { bar.style.width = '100%'; });

    const duration = 1800;
    const start = performance.now();
    const tick = (now) => {
      const elapsed = now - start;
      const t = Math.min(elapsed / duration, 1);
      setPercent(Math.round(t * 100));
      if (t < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);

    const fadeTimer = setTimeout(() => setFading(true), 2200);
    const goneTimer = setTimeout(() => setGone(true), 2900);
    return () => { clearTimeout(fadeTimer); clearTimeout(goneTimer); };
  }, []);

  if (gone) return null;

  return (
    <div className={`loader${fading ? ' fade-out' : ''}`}>
      <div className="loader-logo">VODACOM</div>
      <p className="loader-tagline">THE FUTURE IS EXCITING. READY?</p>
      <div className="loader-bar-section">
        <span className="loader-percent">{percent}%</span>
        <div className="loader-bar">
          <div className="loader-bar-fill" ref={barRef} />
        </div>
      </div>
    </div>
  );
}
